'use client'
import { useState, useEffect, Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import HTMLReactParser from 'html-react-parser'

const TableDropdown = ({ title, headers, content, cols, extraClass }) => {
  const pagination = { resultsByPage: 5 }
  const { resultsByPage } = pagination
  const [pages, setPages] = useState([0])
  const [elements, setElements] = useState(0)
  const [pageCount, setPageCount] = useState('0-0')
  const [pageDynamically, setPageDynamically] = useState(1)
  const currentCount = pageDynamically * resultsByPage - resultsByPage + 1
  const showPagination = content.length > resultsByPage

  useEffect(() => {
    setElements(content.length)
    const pagesSelect = Array.from(
      {
        length: Math.ceil(content.length / resultsByPage)
      },
      (_, i) => ({
        page: i + 1,
        selected: i + 1 === pageDynamically
      })
    )
    setPages(pagesSelect)
    setPageCount(
      `${currentCount > 0 ? currentCount : 0}-${
        parseInt(pageDynamically) === pagesSelect.length
          ? content.length
          : pageDynamically * resultsByPage
      }`
    )
  }, [pageDynamically])

  return (
    <div className="">
      <Popover className="">
        <Popover.Button className="outline-none w-full group">
          {({ open }) => {
            return (
              <div
                className={`group grid grid-cols-3 min-w-full text-white bg-blue hover:text-blue hover:bg-sec-grey-4 ${
                  open ? 'rounded-t-md' : 'rounded-md'
                }`}
              >
                <div className="whitespace-nowrap py-0 lg:py-4 pl-4 pr-3 sm:pl-6">
                  <div className="flex items-center">
                    <div className="ml-4 mr-32 py-5">
                      <div className="text-[18px] lg:text-[25px] group-hover:font-alliance-medium text-left">
                        {HTMLReactParser(title)}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`grid col-span-2 font-alliance-medium content-center justify-end pr-10 ${
                    open ? 'rounded-tr-md' : 'rounded-r-md'
                  }`}
                >
                  {open ? (
                    <></>
                  ) : (
                    <>
                      <img
                        src={`/assets/icons/arrow-simple-down.svg`}
                        alt="icon"
                        className="transition rotate-0 w-6 lg:w-10 group-hover:hidden"
                      />
                      <img
                        src={`/assets/icons/arrow-simple-down-blue.svg`}
                        alt="icon"
                        className="transition rotate-0 w-6 lg:w-10 hidden group-hover:block"
                      />
                    </>
                  )}
                </div>
              </div>
            )
          }}
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 -translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-1"
        >
          <Popover.Panel className="transform">
            <div className="col-span-3">
              <div className="grid grid-cols-1 ">
                <div className="text-styles border-t-2 border-b-2 border-white font-alliance-medium text-blue">
                  <div className="">
                    <div className="block lg:hidden">
                      <div>
                        {content
                          .slice(
                            (pageDynamically - 1) * resultsByPage,
                            (pageDynamically - 1) * resultsByPage +
                              resultsByPage
                          )
                          ?.map((item, idx) => {
                            return (
                              <>
                                <div className="bg-blue text-white text-[18px] font-alliance-light rounded-t-md py-4 pl-4">
                                  {item.name}
                                </div>
                                <div
                                  key={idx}
                                  className="grid grid-cols-1 text-blue font-alliance-medium text-[15px] mb-10"
                                >
                                  {Object.keys(item).map((key, sidx) => {
                                    return (
                                      <>
                                        <div
                                          key={sidx}
                                          className={`grid grid-cols-2 lg:grid-cols-${cols} border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md`}
                                        >
                                          <div className="font-alliance-bold py-2 ml-4">
                                            {headers[key]}:
                                          </div>
                                          <div className="grid py-2 ml-2 mr-2">
                                            {item[key]}
                                          </div>
                                        </div>
                                      </>
                                    )
                                  })}
                                </div>
                              </>
                            )
                          })}
                      </div>
                    </div>
                    <div className="hidden lg:block">
                      <div
                        className={`grid grid-cols-${cols} bg-blue text-white text-[15px] font-alliance-light rounded-t-md py-6 pl-6`}
                      >
                        {headers.map((item, idx) => {
                          return (
                            // <div key={idx} className={1 == idx ? 'col-span-2' : null}>
                            <div key={idx}>{item}</div>
                          )
                        })}
                      </div>
                      <div>
                        {content
                          .slice(
                            (pageDynamically - 1) * resultsByPage,
                            (pageDynamically - 1) * resultsByPage +
                              resultsByPage
                          )
                          ?.map((item, idx) => {
                            return (
                              <div
                                key={idx}
                                className={`grid grid-cols-${cols} text-blue font-alliance-medium pl-6 py-6 text-[15px] border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md`}
                              >
                                {Object.keys(item)?.map((key, sidx) => {
                                  return (
                                    <div
                                      key={sidx}
                                      className={extraClass?.[sidx] || ''}
                                    >
                                      {item[key]}
                                    </div>
                                  )
                                })}
                              </div>
                            )
                          })}
                      </div>
                    </div>

                    {showPagination && (
                      <div className="flex bg-sec-grey-4 bg-opacity-70 mt-8 lg:mt-16 justify-between lg:h-[72px] lg:pl-8 lg:pr-12 px-4">
                        <div className="grid content-center">
                          <span className="text-blue font-alliance-medium text-[12px] lg:text-[15px]">
                            {`${pageCount} de ${elements}`}
                          </span>
                        </div>
                        <div className="grid content-center">
                          <div className="flex">
                            <span className="grid content-center text-blue opacity-30 text-[12px] lg:text-[15px] font-alliance-medium mr-2 lg:mr-4">
                              Estàs a la página
                            </span>
                            <select
                              className="border-none rounded-md text-[12px] lg:text-[15px] font-alliance-medium mr-3 lg:mr-16 focus:ring-0 my-2 lg:my-0"
                              onChange={(e) => {
                                setPageDynamically(e.target.value)
                              }}
                            >
                              {pages.map((item, idx) => (
                                <option key={idx} selected={item.selected}>
                                  {item.page}
                                </option>
                              ))}
                            </select>
                            <button
                              onClick={() => {
                                if (pageDynamically - 1 > 0) {
                                  setPageDynamically(pageDynamically - 1)
                                }
                              }}
                              className="group grid bg-white content-center px-4 rounded-md mr-1 lg:mr-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
                            >
                              <div>
                                <img
                                  src={`/assets/icons/arrow-mini-left.svg`}
                                  alt="left"
                                  className="block group-hover:hidden"
                                />
                                <img
                                  src={`/assets/icons/arrow-mini-left-white.svg`}
                                  alt="left"
                                  className="hidden group-hover:block"
                                />
                              </div>
                            </button>
                            <div className="border-l-2 border-blue border-opacity-10 my-4 lg:my-1"></div>
                            <button
                              onClick={() => {
                                if (pageDynamically + 1 <= pages.length) {
                                  setPageDynamically(pageDynamically + 1)
                                }
                              }}
                              className="group grid bg-white content-center px-4 rounded-md ml-1 lg:ml-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
                            >
                              <div>
                                <img
                                  src={`/assets/icons/arrow-mini-right.svg`}
                                  alt="right"
                                  className="block group-hover:hidden pointer-events-none"
                                />
                                <img
                                  src={`/assets/icons/arrow-mini-right-white.svg`}
                                  alt="right"
                                  className="hidden group-hover:block pointer-events-none"
                                />
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  )
}

export default TableDropdown
